import { FormLabel, Grid } from "@mui/material";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import React from "react";

export default function SwitchCmp({
  Label = "",
  checked,
  onChange,
  onlabel,
  offlabel,
}: {
  Label: string;
  checked: boolean;
  onChange: any;
  onlabel: string;
  offlabel: string;
}) {
  return (
    <Grid container justifyContent={"center"} alignItems={"center"}>
      <Grid item xs={7}>
        <FormLabel
          style={{
            fontFamily: "iranSans",
            color: "#757575",
            verticalAlign: "middle",
            fontSize: "15px",
          }}
        >
          {Label}
        </FormLabel>
      </Grid>
      <Grid
        item
        xs={5}
        // style={{
        //   maxWidth: "6em",
        //   minWidth: "3em",
        //   direction: "initial",
        // }}
      >
        <BootstrapSwitchButton
          style="rounded-pill mb-3"
          checked={checked}
          onlabel={onlabel}
          offlabel={offlabel}
          onChange={onChange}
          onstyle="primary"
        />
      </Grid>
    </Grid>
  );
}
